import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as userFetchList } from "@/api/system/user/user";
import { fetchList, registerAndApprove } from "@/api/PMS/communityPartyBuilding/registrationInformation";
import { fetchList as fetchTypeList } from "@/api/PMS/communityPartyBuilding/activityType";
import waves from "@/directive/waves"; // 水波纹指令

import { formatJson } from "@/utils/index";
export default {
  name: "ComplexTable",
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      userOptions: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        auditStatus: "1",
        activityId: 1,
        isCancel: 0
      },
      id: -1,
      dates: [],
      dates2: [],
      options: [],
      multipleSelection: []
    };
  },
  created: function created() {
    // 获取路由的配置
    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.listQuery.appType = parseInt(appType);
    }

    this.getUser();
    this.getList();
    this.getTypeOption();
  },
  methods: {
    handlAudit: function handlAudit(id, type) {
      var _this = this;

      this.$confirm("你确定要" + (type == 2 ? "审核通过" : "审核不通过") + "吗, 是否继续?", "提示").then(function () {
        registerAndApprove({
          registerDetailId: id,
          auditStatus: type
        }).then(function (res) {
          if (res.data.code == 200) {
            _this.Alert({
              alertType: "update",
              message: "审核成功"
            });

            _this.getList();
          }
        });
      });
    },
    getUser: function getUser() {
      var _this2 = this;

      userFetchList({}).then(function (res) {
        _this2.userOptions = res.data.data;
      });
    },
    getList: function getList() {
      var _this3 = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      if (this.dates2 !== null && this.dates2.length > 0) {
        this.listQuery.registrationBeginDate = this.dates2[0];
        this.listQuery.registrationEndDate = this.dates2[1];
      } else {
        this.listQuery.registrationBeginDate = "";
        this.listQuery.registrationEndDate = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this3.list = response.data.data;
        _this3.total = response.data.total;
        _this3.listLoading = false;
      });
    },
    getTypeOption: function getTypeOption() {
      var _this4 = this;

      fetchTypeList({
        page: 1,
        appType: this.listQuery.appType
      }).then(function (res) {
        _this4.options = res.data.data;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    handleExport: function handleExport() {
      var _this5 = this;

      this.exLists = [];
      this.$confirm("你确定要导出职工活动审批情况吗, 是否继续?", "提示").then(function () {
        var beginDate = "";
        var endDate = "";

        if (_this5.dates !== null && _this5.dates.length > 0) {
          beginDate = _this5.dates[0];
          endDate = _this5.dates[1];
        }

        var beginDate2 = "";
        var endDate2 = "";

        if (_this5.dates2 !== null && _this5.dates2.length > 0) {
          beginDate2 = _this5.dates2[0];
          endDate2 = _this5.dates2[1];
        }

        fetchList({
          activityTitle: _this5.listQuery.activityTitle,
          activityId: _this5.listQuery.activityId,
          itemName: _this5.listQuery.itemName,
          coachId: _this5.listQuery.coachId,
          endDate: endDate,
          beginDate: beginDate,
          registrationEndDate: endDate2,
          registrationBeginDate: beginDate2,
          auditStatus: _this5.listQuery.auditStatus
        }).then(function (response) {
          var list = response.data.data;

          if (list !== null && list.length > 0) {
            list.forEach(function (element) {
              switch (element.auditStatus) {
                case 1:
                  element.auditStatus = "未审核";
                  break;

                case 2:
                  element.auditStatus = "审核通过";
                  break;

                case 3:
                  element.auditStatus = "审核不通过";
                  break;

                default:
                  break;
              }
            });
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["项目名称", "项目类型", "报名内容", "活动开始时间", "活动结束时间", "微信昵称", "报名时间", "学员姓名", "联系方式", "证件号码", "备注", "审核状态"];
              var fileterVal = ["activityTitle", "activityTypeName", "itemName", "activityBeginDate", "activityEndDate", "nickName", "enrollmentTime", "studentName", "tel", "idCard", "remark", "auditStatus"];
              var data = formatJson(fileterVal, list);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: "职工活动审批",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this5.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};